import { useCreate, useOne, useParsed } from "@refinedev/core";
import { useState } from "react";

export const useDuplicateConfig = ({
    type,
    page,
}: {
    type: "explore-listing" | "explore-edit";
    page: "ab-test" | "intelligence-search" | "intelligence-searches";
}) => {
    const [id, setId] = useState<string | undefined>(undefined);
    const params = useParsed();
    const _id = id || params.id;
    const { mutateAsync: createNewConfig } = useCreate();
    const { refetch, isFetching } = useOne({
        id: _id,
        resource: "explorations",
        dataProviderName: "nestjsx",
        queryOptions: {
            enabled: false,
            queryKey: ["explorations", "duplicate", _id],
            onSuccess: async (data) => {
                delete data.data?.updated_at;
                delete data.data?.updated_by;
                delete data.data?.created_at;
                delete data.data?.is_public;
                delete data.data?.id;
                const _data = {
                    ...data?.data,
                    title: data?.data?.title + " (Copy)",
                };
                const newConfigDuplicated = await createNewConfig({
                    dataProviderName: "nestjsx",
                    resource: "explorations",
                    values: _data,
                    meta: {
                        headers: {
                            "product-code": data?.data?.product_code,
                        },
                    },
                });
                if (newConfigDuplicated?.data) {
                    let newUrl = "";
                    if (page === "ab-test") {
                        newUrl = `${window.location.origin}/explorations/ab-test/${newConfigDuplicated?.data?.id}`;
                    }
                    if (page === "intelligence-search") {
                        newUrl = `${window.location.origin}/explorations/intelligence-search/${newConfigDuplicated?.data?.id}`;
                    }
                    if (page === "intelligence-searches") {
                        newUrl = `${window.location.origin}/explorations/intelligence-searches/${newConfigDuplicated?.data?.id}`;
                    }
                    if (type === "explore-listing") {
                        window.location.replace(newUrl);
                    } else {
                        window.open(newUrl, "_blank");
                    }
                }
            },
        },
    });

    const handleRefetch = (id?: any) => {
        setId(id);
        setTimeout(() => {
            refetch();
        }, 200);
    };
    return {
        refetch: handleRefetch,
        loading: isFetching,
    };
};
